export default (theme) => ({
    root: {
        display: 'block',
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
    },
    text: {
        padding: '8px 0',
    },
});
